export enum AtividadeColetivaGrupoCabecalho {
  MEUS_GRUPOS = 'MEUS_GRUPOS',
  OUTROS_GRUPOS = 'OUTROS_GRUPOS',
}

export enum AtividadeColetivaGrupoSemResultados {
  SEM_RESULTADOS_ENCONTRADOS = 'SEM_RESULTADOS_ENCONTRADOS',
}

export type AtividadeColetivaGrupoItemModel = {
  nome: string
  equipesEnvolvidas: string
  unidadeDeSaude: string
  cidadaos: ID[]
}

export type AtividadeColetivaGrupoSelectItemModel =
  | AtividadeColetivaGrupoCabecalho
  | AtividadeColetivaGrupoSemResultados
  | AtividadeColetivaGrupoItemModel
